import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  EquipmentType,
  EquipmentTypeValues,
  ImpactCo2Answer,
  ValuesEquipment,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'EQUIPMENT';
const SECTORS: Sector[] = ['SITE'];

export function mapToEquipmentAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesEquipment>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const rentedEquipmentType = mapToRentedEquipmentType(row);
  const rentalDays = mapToRentalDays(row);
  const quantity = mapToQuantity(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      rentedEquipmentType,
      rentalDays,
      quantity,
    },
  };
  return answer;
}

function mapToRentedEquipmentType(row: ImportedRow): EquipmentType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<EquipmentType>(
    tgsValue,
    EquipmentTypeValues,
  );
  if (!result) {
    throw new ImportMappingError('rentedEquipmentType', tgsValue, row);
  }
  return result;
}

function mapToRentalDays(row: ImportedRow): number {
  const tgsValue = row['rentalDays'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('rentalDays', tgsValue, row);
  }
  return result;
}

function mapToQuantity(row: ImportedRow): number {
  const tgsValue = row['Quantity'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('quantity', tgsValue, row);
  }
  return result;
}
